import { ewent } from "./reactive";
import { util } from "./util/util";
var delay = util.delay;
export class Process {
    constructor() {
        this.finished_event = ewent();
        this.is_running = false;
        this.should_stop = false;
        this.finished = false;
        this.interrupt_settings = {
            interrupt: {
                interval: 50,
                length: 1
            }
        };
        this.timeout = Number.MAX_SAFE_INTEGER;
        this.interrupt_ewent = ewent();
    }
    asInterval(interval) {
        this.interrupt_settings = {
            interval: interval
        };
        return this;
    }
    withInterrupt(interval, length) {
        this.interrupt_settings = {
            interrupt: {
                interval: interval,
                length: length,
            }
        };
        return this;
    }
    withTimeout(timeout) {
        this.timeout = timeout;
        return this;
    }
    async run() {
        if (this.is_running || this.finished)
            return null;
        this.is_running = true;
        this.should_stop = false;
        this.start_time = Date.now();
        this.end_time = this.start_time + this.timeout;
        this.last_interrupt_time = this.start_time;
        const result = await this.implementation();
        this.is_running = false;
        this.should_stop = false;
        this.finished = true;
        this.finished_event.trigger(undefined);
        return result;
    }
    isFinished() {
        return this.finished;
    }
    onInterrupt(f) {
        this.interrupt_ewent.on(f);
        return this;
    }
    async interrupt(length) {
        this.interrupt_ewent.trigger(null);
        await delay(length);
    }
    stop() {
        if (!this.is_running)
            return;
        this.should_stop = true;
    }
    await() {
        return new Promise(resolve => {
            if (this.finished)
                resolve(this);
            else
                this.finished_event.on(() => resolve(this));
        });
    }
    async checkTime() {
        const t = Date.now();
        if (this.interrupt_settings.interval) {
            await this.interrupt(Math.max(this.interrupt_settings.interval / 2, (this.last_interrupt_time + this.interrupt_settings.interval) - t));
        }
        else {
            if (t >= this.end_time)
                this.stop();
            else if (t >= this.last_interrupt_time + this.interrupt_settings.interrupt.interval) {
                this.last_interrupt_time = t;
                await this.interrupt(this.interrupt_settings.interrupt.length);
            }
        }
    }
    onFinished(f) {
        this.finished_event.on(() => f(this));
        return this;
    }
}
(function (Process) {
    class Interval extends Process {
        constructor(interval) {
            super();
            this.asInterval(interval);
        }
        async implementation() {
            while (!this.should_stop) {
                await this.tick();
                await this.checkTime();
            }
        }
    }
    Process.Interval = Interval;
})(Process || (Process = {}));
